import t from "./contact-channels80.js";
import m from "./contact-channels81.js";
function a(r, i) {
  return t(m(r));
}
export {
  a as default
};
//# sourceMappingURL=contact-channels63.js.map
